var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { ref, onMounted, computed, onBeforeUnmount, nextTick, watch } from 'vue';
import PerfectScrollbar from 'perfect-scrollbar';
import { addResizeListener, removeResizeListener } from '@common/utils/ResizeEvent';
import { sleep } from '@common/utils/Helpers/Helpers';
export default /*#__PURE__*/ _defineComponent({
    __name: 'EScrollbar',
    props: {
        options: {},
        visible: { type: Boolean, default: true },
        contentClass: { default: '' }
    },
    emits: ["scroll", "ps-scroll-y", "ps-scroll-x", "ps-scroll-up", "ps-scroll-down", "ps-scroll-left", "ps-scroll-right", "ps-y-reach-start", "ps-y-reach-end", "ps-x-reach-start", "ps-x-reach-end"],
    setup: function (__props, _a) {
        var _this = this;
        var __expose = _a.expose, __emit = _a.emit;
        var props = __props;
        var emit = __emit;
        var eventNames = [
            'scroll',
            'ps-scroll-y',
            'ps-scroll-x',
            'ps-scroll-up',
            'ps-scroll-down',
            'ps-scroll-left',
            'ps-scroll-right',
            'ps-y-reach-start',
            'ps-y-reach-end',
            'ps-x-reach-start',
            'ps-x-reach-end'
        ];
        var rootRef = ref(null);
        var perfectScrollbar = ref();
        var latestWidth = ref(0);
        var latestHeight = ref(0);
        var resizeTargetEl = null;
        var update = function () { var _a; return (_a = perfectScrollbar.value) === null || _a === void 0 ? void 0 : _a.update(); };
        var setupScrollbar = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, nextTick()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, sleep(1000)];
                    case 2:
                        _a.sent();
                        initPerfectScrollbar();
                        if (rootRef.value) {
                            resizeTargetEl = rootRef.value;
                            addResizeListener(resizeTargetEl, onResize);
                        }
                        requestAnimationFrame(update);
                        return [2 /*return*/];
                }
            });
        }); };
        var cleanupScrollbar = function () {
            destroyPerfectScrollbar();
            removeResizeListener(rootRef.value, onResize);
        };
        onMounted(function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!props.visible) return [3 /*break*/, 2];
                        return [4 /*yield*/, setupScrollbar()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); });
        onBeforeUnmount(function () {
            cleanupScrollbar();
        });
        watch(function () { return props.visible; }, function (v) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (props.visible !== undefined) {
                    v ? setupScrollbar() : cleanupScrollbar();
                }
                return [2 /*return*/];
            });
        }); });
        var computedOptions = computed(function () {
            return __assign({ minScrollbarLength: 20 }, props.options);
        });
        var initPerfectScrollbar = function () {
            var e_1, _a;
            if (!perfectScrollbar.value && rootRef.value) {
                perfectScrollbar.value = new PerfectScrollbar(rootRef.value, computedOptions.value);
                var _loop_1 = function (eventName) {
                    perfectScrollbar.value.element.addEventListener(eventName, function (event) { return emit(eventName, event); });
                };
                try {
                    for (var eventNames_1 = __values(eventNames), eventNames_1_1 = eventNames_1.next(); !eventNames_1_1.done; eventNames_1_1 = eventNames_1.next()) {
                        var eventName = eventNames_1_1.value;
                        _loop_1(eventName);
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (eventNames_1_1 && !eventNames_1_1.done && (_a = eventNames_1.return)) _a.call(eventNames_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            }
        };
        var destroyPerfectScrollbar = function () {
            setTimeout(function () {
                var _a;
                (_a = perfectScrollbar.value) === null || _a === void 0 ? void 0 : _a.destroy();
                perfectScrollbar.value = undefined;
            }, 1000);
        };
        var onResize = function (e) {
            var _a;
            if (
            // При скрытии родительских блоков значения будут равняться 0, не нужно реагировать в этом случае
            !(e.contentRect.width === 0 && e.contentRect.height === 0)
                && (latestWidth.value !== e.contentRect.width
                    || latestHeight.value !== e.contentRect.height)) {
                latestWidth.value = e.contentRect.width;
                latestHeight.value = e.contentRect.height;
                (_a = perfectScrollbar.value) === null || _a === void 0 ? void 0 : _a.update();
            }
        };
        var scrollToBottom = function () {
            rootRef.value.scrollTop = rootRef.value.scrollHeight;
        };
        var scrollToTop = function () {
            rootRef.value.scrollTop = 0;
        };
        var scrollTo = function (position) {
            if (!rootRef.value || !perfectScrollbar.value)
                return;
            rootRef.value.scrollTop = position;
        };
        __expose({
            scrollToTop: scrollToTop,
            scrollToBottom: scrollToBottom,
            update: update,
            scrollTo: scrollTo,
            rootRef: rootRef
        });
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", _mergeProps(_ctx.$attrs, {
                ref_key: "rootRef",
                ref: rootRef,
                class: [_ctx.contentClass, "e-scrollbar"]
            }), [
                _renderSlot(_ctx.$slots, "default")
            ], 16));
        };
    }
});
